import { useMemo } from 'react';

import { useFastshiftSelector } from '@/state';

import { BaseIdentityAttrs } from '../types';

export const useBaseIdentityAttrs = (): BaseIdentityAttrs | null => {
	const { data: user } = useFastshiftSelector((state) => state.userAccess);

	return useMemo(() => {
		if (!user) return null;
		return {
			role: user.userType,
			userDomain: user.userDomain.domain,
		};
	}, [user]);
};
